<template>
  <div>
    <h6 class="font-semibold my-20">
      {{
        $route.params.id ? "Cập nhật package" : "Thêm mới package"
      }}
    </h6>
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tên package" prop="title">
          <a-input v-model="form.title" placeholder="Tên package" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Mô tả" prop="description">
          <a-input v-model="form.description" placeholder="Mô tả" />
        </a-form-model-item>
        <a-form-model-item
          class="mb-5"
          label="Loại"
          prop="type"
        >
          <a-select
            v-model="form.type"
            class="w-full"
            placeholder="Chọn"
            show-search
            allowClear
            option-filter-prop="children"
            @change="changeTypeService"
          >
            <a-select-option
              v-for="item in listCategory"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          class="mb-5"
          label="Service hoặc Product"
          prop="service_id"
        >
          <a-select
            v-model="form.service_id"
            class="w-full"
            placeholder="Chọn"
            show-search
            allowClear
            option-filter-prop="children"
          >
            <a-select-option
              v-for="item in seriveOptions"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Giá" prop="price">
          <a-input v-model="form.price" class="w-full" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Trạng thái hiển thị" prop="status">
            <a-switch default-checked v-model="form.status" />
        </a-form-model-item>
        <a-form-model-item
          class="mb-5"
          label="Nội dung"
          prop="content"
        >
          <ckeditor :editor="editor" v-model="form.content" :height="500" :config="editorConfig"></ckeditor>
        </a-form-model-item>
        <a-row type="flex" justify="end" class="mt-20">
          <a-button type="primary" :loading="callingAPI" @click="handleSubmit">
            {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
          </a-button>
        </a-row>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import {
  fetchPackageById,
  updatePackage,
  createPackage
} from "@/services/landing-page/package";

import { fetchService } from '@/services/landing-page/home/service'
import { fetchProductService } from '@/services/landing-page/home/product-service-trying'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


export default {
  name: "PackageController",
  data() {
    return {
      callingAPI: false,
      editor: ClassicEditor,
      editorConfig: {
        height: 500
      },
      listCategory: [
        {
          id: 1,
          name: 'Service',
        },
        {
          id: 2,
          name: 'Product',
        }
      ],
      seriveOptions: [],
      form: {
        title: "",
        description: "",
        content: "",
        status: true,
        price: null,
        type: null,
        service_id: null
      },
      rules: {
        title: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        content: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        price: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        type: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
         service_id: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ]
      }
    }
  },
  async created() {
    if (this.$route.params.id) {
      await this.loadData();
    }
  },
  methods: {

    async loadData() {
      try {
        const response = await fetchPackageById(this.$route.params.id);
        for (var key in this.form) {
          if (response.data.hasOwnProperty(key)) {
            if (key === 'status') {
               this.form[key] = response.data[key] === 1 ? true : false
            } else {
              this.form[key] = response.data[key];
            }
          }
        }
        await this.getServiceOptions()
      } catch (error) {}
    },
    async handleSubmit() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            this.callingAPI = true;
            const data = {
              ...this.form,
              status: this.form.status ? 1 : 2
            };
            let message;
            if (this.$route.params.id) {
              data._method = "PUT";
              await updatePackage(this.$route.params.id, data);
            } else {
              await createPackage(data);
            }
            this.callingAPI = false;
            message = this.$route.params.id
              ? "Cập nhật thành công"
              : "Thêm mới thành công";
            this.$notification.success({
              message: "Thành công",
              description: message,
            });
            this.$router.push({path: "/our-bussiness/packages"})
          }
        });
      } catch (error) {
        this.callingAPI = false;
        let message = this.$route.params.id
          ? "Cập nhật thất bại"
          : "Thêm mới thất bại";
        this.$notification.error({
          message: "Thất bại",
          description: message
        });
      }
    },
    async getServiceOptions() {
      try {
        const response = this.form.type === 1 ? await fetchService() : await fetchProductService()
        this.seriveOptions = response?.data?.filter(item => item.type !== 1 && item.high_light !== 1).map(item => ({ id: item.id, name: item.name || item.title })) || [];
      } catch (error) {}
    },
    async changeTypeService() {
      this.form.service_id = null
      this.seriveOptions = []
      await this.getServiceOptions()
    }
  },
};
</script>

<style lang="scss" scoped>
</style>